












import { Component, Prop, Vue } from 'vue-property-decorator';
import AnalyticChart from '@/components/dashboard/analytics/AnalyticChart.vue';
import AnalyticEmpty from '@/components/dashboard/analytics/AnalyticEmpty.vue';
import AnalyticSteps from '@/components/dashboard/analytics/AnalyticSteps.vue';

@Component({
    components: {
        AnalyticSteps,
        AnalyticEmpty,
        AnalyticChart,
    },
})
export default class Analytics extends Vue {
    /* eslint-disable global-require */
    public stepList = [
        {
            step: 1,
            details: 'Click add product to generate your blockchain certificates with your product details and images. <b><a href="https://youtu.be/XdJ9iO6SEGs" target="_blank">You can view the tutorial here</a></b>',
            src: require('@/assets/images/dashboard/group-4370.svg'),
        },
        {
            step: 2,
            details: 'Add NFC link generated from our platform on your products. You can order the NFC tags from us!',
            src: require('@/assets/images/dashboard/group-4371.svg'),
        },
        {
            step: 3,
            details: 'These products are verifiable by scanning the Papyrus-linked NFC tags with the LuxTag mobile app',
            src: require('@/assets/images/dashboard/group-4372.svg'),
        },
    ];

    get products() {
        return this.$store.getters.getProducts;
    }
    /* eslint-enable global-require */
}
